import omit from 'lodash.omit';

import { ComponentRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MmAlertService } from '@metromarkets/components';

import { IAsyncValidationError } from '../models/advanced-form-validation.model';

export class FormErrorHandler {
  private formErrorAlertRef: ComponentRef<any>;

  constructor(
    private formGroup: FormGroup,
    private alertService: MmAlertService,
  ) {}

  public handleAsyncValidationError(asyncValidationError: IAsyncValidationError): void {
    const formError = asyncValidationError['null'];
    const fieldErrors = omit(asyncValidationError, 'null');

    if (formError) {
      this.setFormError(formError.reason, formError.title);
    }

    this.setFieldErrors(fieldErrors);
  }

  public resetFormError(): void {
    if (this.formErrorAlertRef) {
      this.formErrorAlertRef.destroy();
      this.formErrorAlertRef = null;
    }
  }

  private setFormError(formErrorMessage: string, formErrorTitle?: string): void {
    this.formErrorAlertRef = this.alertService.addAlert({
      ...(formErrorTitle && formErrorTitle.length ? {title: formErrorTitle} : {}),
      message: formErrorMessage,
      target: `.fn-form-error-alert`,
      type: 'error',
      mode: 'alert',
      size: 'large',
      contentAlign: 'center',
    });
  }

  private setFieldErrors(asyncValidationError: IAsyncValidationError): void {
    Object.keys(asyncValidationError).forEach((fieldName: string) => {
      const fieldAsyncError = asyncValidationError[fieldName];
      const formControl = this.formGroup.get(fieldName);
      if (formControl) {
        formControl.setErrors({ async: fieldAsyncError });
      }
    });
  }
}
